import { defineAsyncComponent } from 'vue'
export default {
  "no-nav": defineAsyncComponent(() => import("/builds/marketing/website-2.0/layouts/NoNav.vue").then(m => m.default || m)),
  "no-nav-light": defineAsyncComponent(() => import("/builds/marketing/website-2.0/layouts/NoNavLight.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/marketing/website-2.0/layouts/default.vue").then(m => m.default || m))
}